document.addEventListener('DOMContentLoaded', function () {
    let iframe = document.querySelector('.maier-container-configurator-fred > iframe');
    if (null !== iframe) {
        iframe.addEventListener('load', function () {
            window.addEventListener('message', (event) => {
                if (event.data.manille && event.data.cable){
                    if (!event.data.taille) {
                        Toast.error(this.getAttribute('data-error-size-message') ?? 'An error has occured.', 5000);

                        return;
                    }

                    window.location.href = this.getAttribute('data-url-prototype').replace('__fred_reference__', event.data.manille + "-" + event.data.cable + (event.data.taille ? "-" + event.data.taille : ""));
                }

            }, false);
        });
    }
})